import { useAuth0 } from '@auth0/auth0-react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import LayoutDefault from "src/components/LayoutDefault";
import { useGetUserData } from 'src/hooks/user';
import { setUserCompanies } from 'src/redux/reducers/user';

export default function Root() {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate])

  const { data: userData } = useGetUserData();

  useEffect(() => {
    if (userData) {
      dispatch(setUserCompanies(userData));
    }
  }, [userData, dispatch]);

  return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LayoutDefault />
      </LocalizationProvider>
  );
}
